import { StaticImage } from 'gatsby-plugin-image'
import React from 'react'

import * as styles from './rebalance.module.scss'
import IntroBanner from '../../components/banners/intro-banner/IntroBanner'
import RequestAccess from '../../components/request-access/RequestAccess'
import CommencementSection from '../../components/sections/commencementSection/CommencementSection'
import ReviewSection from '../../components/sections/review-section/ReviewSection'
import SplitSection from '../../components/sections/splitSection/SplitSection'
import TwinFeatureSection from '../../components/sections/twin-feature-section/TwinFeatureSection'
import SEOControl from '../../components/seoControl/seoControl'
import StoresBlock from '../../components/storesBlock/StoresBlock'
import { SvgCheck } from '../../components/ui/svg-icons/SvgCheck'
import WantToKnowMore from '../../components/want-to-know-more/WantToKnowMore'
import { reviews } from '../../constants/reviews'
import { colors } from '../../constants/style'

const TITLE = 'Bamboo App Features - Rebalance | Restructure Your Portfolio'
const DESCRIPTION =
  'Control your risk tolerance securely by changing the composition of your portfolio as an when you choose with the Bamboo rebalance feature.'
const KEYWORDS =
  'bamboo, blockchain, gold, silver, precious metals, bitcoin, ethereum, digital assets, litecoin, crypto, buy, invest, invest today, micro investment, microinvestment, micro-investment, solvency protocol, proof of solvency, spare change, budget'

function RebalancePage({ pageContext }) {
  const BannerImage = (
    <StaticImage
      src="../../assets/images/Rebalance.png"
      alt="Bamboo investments App"
      width={540}
    />
  )
  const AssetImage = (
    <StaticImage
      src="../../assets/images/Rebalance_Asset.png"
      alt="Bamboo investments App"
      width={540}
      height={720}
    />
  )

  return (
    <>
      <SEOControl title={TITLE} description={DESCRIPTION} keywords={KEYWORDS} />

      <IntroBanner
        title="Restructure your portfolio"
        subHeading="Rebalance your portfolio mix across crypto and Gold and Silver Standard."
        backgroundImage={BannerImage}
        backgroundColor={colors.citrus50}
      />

      <SplitSection
        subTitle="Rebalance"
        title="Easily adjust your portfolio composition"
        text="Making it seamless to rebalance at any time"
        renderedImage={
          <StaticImage
            src="../../assets/images/Rebalance-DontMissOut.jpg"
            alt="Bamboo investments App"
            width={540}
            height={540}
          />
        }
      />

      <IntroBanner
        heading="In the market for effortless investing?"
        subHeading="Start your journey with us."
        appendItems={<StoresBlock className={styles.storeButtons} />}
        backgroundImage={AssetImage}
        fullImageHeight
        backgroundColor={colors.tealA400}
        imageBottomOnMobile
      />
      <SplitSection
        subTitle="Rebalance"
        title="Restructure the composition of your portfolio. Finding the right balance has never been easier."
        text={
          <ul className={styles.list}>
            <li>
              <SvgCheck />
              Manage your investments in line with your risk tolerance by
              changing your portfolio composition as and when you choose
            </li>
            <li>
              <SvgCheck />
              Transfer from one asset to another with one click.
            </li>
          </ul>
        }
        renderedImage={
          <StaticImage
            src="../../assets/images/Rebalance_BTC.jpg"
            alt="Bamboo investments App"
            width={540}
            height={540}
          />
        }
      />
      <ReviewSection {...reviews[1]} />
      <CommencementSection horizontal />
      <RequestAccess />
      <TwinFeatureSection featuresList={['SMSF', 'Round-ups', 'Top-ups']} />
      <WantToKnowMore />
    </>
  )
}

export default RebalancePage
